interface ProductQuantityControlsProps {
  quantity: number;
  stock: number;
  onQuantityChange: (quantity: number) => void;
}

export const ProductQuantityControls = ({ 
  quantity, 
  stock, 
  onQuantityChange 
}: ProductQuantityControlsProps) => {
  return (
    <div className="flex items-center gap-4">
      <div className="flex items-center border rounded-lg">
        <button
          onClick={() => onQuantityChange(Math.max(1, quantity - 1))}
          className="px-3 py-2 text-gray-600 hover:text-gray-800"
        >
          -
        </button>
        <span className="px-4 py-2 border-x">{quantity}</span>
        <button
          onClick={() => onQuantityChange(Math.min(stock, quantity + 1))}
          className="px-3 py-2 text-gray-600 hover:text-gray-800"
        >
          +
        </button>
      </div>
    </div>
  );
};